import '../css/comments.css';
import { formatRelativeTime } from '../../../../format/formatDate';

const CommentItem = ({
  editorRef,
  ableId,
  item,
  userInfo,
  setRemoveId,
  setRemoveShow,
  setReplyUser,
  setMinMessageReply,
  formData,
  setFormData,
}) => {
  const handleRemove = (id) => {
    setRemoveId(id);
    setRemoveShow(true);
  };

  const handleReply = (idCmt, idUser, fullName) => {
    setMinMessageReply(false);
    if (formData.parentId === idCmt) {
      setFormData({
        ableId,
        content: '',
        replyTo: null,
        parentId: null,
      });
    } else {
      // if (editorRef.current) {
      //   const editor = editorRef.current;
      //   const text = `${fullName} `;

      //   editor.innerHTML = `<strong className='reply-name'>${text}</strong>&nbsp;`;

      setReplyUser(fullName);

      setFormData((prev) => ({
        ...prev,
        content: '',
        replyTo: idUser,
        parentId: idCmt,
      }));
      //   const range = document.createRange();
      //   const sel = window.getSelection();
      //   range.selectNodeContents(editor);
      //   range.collapse(false);
      //   sel.removeAllRanges();
      //   sel.addRange(range);

      //   editor.focus();
      // }
    }
  };

  return (
    <article>
      <div
        className="item-content"
        style={{
          border:
            formData.parentId === item.id && '2px solid var(--color-second)',
        }}
      >
        <div
          className="arrow"
          style={{
            borderLeft:
              formData.parentId === item.id && '2px solid var(--color-second)',
            borderTop:
              formData.parentId === item.id && '2px solid var(--color-second)',
          }}
        ></div>
        <div className="d-flex">
          <h4>{item.user.full_name}</h4>
          {userInfo && item.user.id === userInfo.userInformation.id && (
            <span
              onClick={() => handleRemove(item.id)}
              className="btn btn-remove-cmt ms-auto"
            >
              <i className="fas fa-times"></i>
            </span>
          )}
        </div>
        <p>
          <b style={{ color: 'var(--blue)' }}>
            {item.replyToUser && item.replyToUser.full_name}
            &nbsp;
          </b>
          {item.content}
        </p>
      </div>
      <div className="d-flex">
        <h5>{formatRelativeTime(item.createdAt)}</h5>
        <h5
          style={{
            color: formData.parentId === item.id && 'var(--color-primary)',
          }}
          className="btn-reply"
          onClick={() =>
            handleReply(item.id, item.user.id, item.user.full_name)
          }
        >
          Trả lời
        </h5>
      </div>
    </article>
  );
};

export default CommentItem;
